import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { getTvHall1Data, getTvHall2Data } from '../../../../services/api';
import TvTheater from './tvTheater';
import TvSideslip from './tvSideslip';

class TvHall extends React.PureComponent {
    static propTypes = {
        isVideoShare: PropTypes.bool,
    };

    tvRef = React.createRef();

    state = {
        hitTv1: [],
        hitTv2: {},
    };

    componentDidMount() {
        window.addEventListener('scroll', this.countDistance);
    }

    countDistance = () => {
        const windowHeight = window.innerHeight;
        const distanceBottomHeight = 30;

        if (this.tvRef.current.getBoundingClientRect().top - windowHeight < distanceBottomHeight) {
            window.removeEventListener('scroll', this.countDistance);
            this.getTvHandle();
        }
    };

    getTvHandle = async () => {
        const hitTv1 = await getTvHall1Data();
        const hitTv2 = await getTvHall2Data();

        this.setState({
            hitTv1,
            hitTv2,
        });
    };

    render() {
        const { isVideoShare } = this.props;
        const { hitTv1, hitTv2 } = this.state;

        return (
            <setion aria-label="正在热播" ref={this.tvRef}>
                {hitTv1.length > 0 && <TvTheater hitTv1={hitTv1} isVideoShare={isVideoShare} />}
                {hitTv2?.title && <TvSideslip hitTv2={hitTv2} isVideoShare={isVideoShare} />}
            </setion>
        );
    }
}

export default errorBoundary(TvHall);
